/**
 * Root Imports
*/

import { ApiRequest } from '~/util/Api';

/**
 * Locals
*/

const endpoint = '/api/v1/abilities';

/**
 * Exports
*/

/**
 * 
 */
export function IndexAbilityService() {
  const config = {
    method: 'GET',
    uri: endpoint
  };

  return ApiRequest(config);
}

/**
 * 
 */
export function ShowAbilityService({ id }) {
  const config = {
    method: 'GET',
    uri: `${ endpoint }/${ id }`
  };

  return ApiRequest(config);
}